



























































import Loader from '@/contexts/frontend/Loader.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

library.add(faPencilAlt, faTrashAlt, faSearch, faTimes)

export default {
  components: {
    loader: Loader
  },
  data: function() {
    return {
      loading: false,
      clients: [],
      clientStartsWith: ''
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .ListClients()
      .then(results => (this.clients = results))
      .finally(() => (this.loading = false))
  },
  methods: {
    findClients() {
      if (this.clientStartsWith.length > 1) {
        this.$api.clientAdmin
          .FindClients(this.clientStartsWith)
          .then(results => (this.clients = results))
      } else if (this.clientStartsWith.length == 0) {
        this.loading = true
        this.$api.clientAdmin
          .ListClients()
          .then(results => (this.clients = results))
          .finally(() => (this.loading = false))
      }
    },
    clearSearch() {
      this.clientStartsWith = ''
      this.findClients()
    }
  },
  computed: {
    clientsFound() {
      return this.clients.length > 0
    },
    hasSearchCriteria() {
      return this.clientStartsWith.length > 0
    }
  }
}
